export const isValidSessionToken = (sessionToken: string | null) => {
  if (!sessionToken || sessionToken.length < 1) {
    return false;
  } else {
    return true
  }
}
